import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PolicySubmissionArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-227.000000, -46.000000)"
      >
        <g transform="translate(227.000000, 46.000000)">
          <path
            d="M-0.0001,15 C-0.0001,23.284 6.7159,30 14.9999,30 C23.2839,30 29.9999,23.284 29.9999,15 C29.9999,6.715 23.2839,0 14.9999,0 C6.7159,0 -0.0001,6.715 -0.0001,15"
            fill="#8C2A8E"
          />
          <path
            d="M8.9999,22.352 C8.9999,22.862 9.4179,23.28 9.9279,23.28 L20.3459,23.28 C20.8559,23.28 21.2739,22.862 21.2739,22.352 L21.2739,11.082 C21.2739,10.572 20.9909,9.847 20.6449,9.472 L18.5489,7.199 C18.2029,6.824 17.5019,6.517 16.9919,6.517 L9.9279,6.517 C9.4179,6.517 8.9999,6.935 8.9999,7.445 L8.9999,22.352 Z"
            fill="#ffffff"
            className={styles.white}
          />
          <polyline
            points="17.9198 6.517 17.9198 10.164 21.2738 10.154"
            stroke="#8C2A8E"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <line
            stroke="#8C2A8E"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="18.405"
            y1="11.8183"
            y2="11.8183"
          />
          <line
            stroke="#8C2A8E"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="18.405"
            y1="15.5952"
            y2="15.5952"
          />
          <line
            stroke="#8C2A8E"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="15.904"
            y1="17.4404"
            y2="17.4404"
          />
          <line
            stroke="#8C2A8E"
            strokeLinejoin="round"
            strokeWidth="0.5"
            x1="11.33"
            x2="18.405"
            y1="13.7006"
            y2="13.7006"
          />
          <path
            d="M15.1444,20.0048 C15.1444,22.2138 16.9354,24.0048 19.1444,24.0048 C21.3534,24.0048 23.1444,22.2138 23.1444,20.0048 C23.1444,17.7958 21.3534,16.0048 19.1444,16.0048 C16.9354,16.0048 15.1444,17.7958 15.1444,20.0048"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M15.1444,20.0048 C15.1444,22.2138 16.9354,24.0048 19.1444,24.0048 C21.3534,24.0048 23.1444,22.2138 23.1444,20.0048 C23.1444,17.7958 21.3534,16.0048 19.1444,16.0048 C16.9354,16.0048 15.1444,17.7958 15.1444,20.0048 Z"
            stroke="#8C2A8E"
            strokeLinejoin="round"
            strokeWidth="0.5"
          />
          <path
            d="M19.2274,21.0009 L18.6304,21.0009 L18.4524,17.5099 L19.4024,17.5099 L19.2274,21.0009 Z M18.4114,22.0949 C18.4114,21.9259 18.4554,21.7969 18.5444,21.7089 C18.6344,21.6209 18.7604,21.5769 18.9254,21.5769 C19.0874,21.5769 19.2124,21.6229 19.2994,21.7139 C19.3864,21.8059 19.4294,21.9329 19.4294,22.0949 C19.4294,22.2569 19.3854,22.3859 19.2974,22.4799 C19.2094,22.5749 19.0854,22.6229 18.9254,22.6229 C18.7634,22.6229 18.6364,22.5769 18.5464,22.4859 C18.4564,22.3949 18.4114,22.2639 18.4114,22.0949 L18.4114,22.0949 Z"
            fill="#8C2A8E"
          />
        </g>
      </g>
    </Icon>
  )
}
